module.exports = __webpack_public_path__ + "assets/img/tit3.cb5fdbcc.png";